<template>
  <div class="c-closedDays">
    <div
      class="o-heading o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsClosedDays.sectionName || name }}
          </h3>
        </div>
      </div>
    </div>
    <div
      v-for="(exeption, index) in availabilityAll.closed"
      :key="index"
      class="o-grid o-grid--padding-none o-grid--align-items-center o-field o-field--spacing-none o-field--border"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--3">
          <div class="o-label" :title="translationsClosedDays.closed || ''">
            {{ translationsClosedDays.closed || "" }}
          </div>
        </div>
        <div class="o-grid__item o-grid__item--8">
          <div
            class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                {{ translationsClosedDays.fromDate || "" }}
              </div>
              <div class="o-grid__item o-grid__item--4">
                <v-datepicker
                  :disabled="!isEditing"
                  input-class="c-aed-editableDate__input"
                  wrapper-class="c-aed-editableDate__wrap"
                  calendar-class="c-aed-editableDate__calendar"
                  v-model="exeption.begin"
                  :use-utc="false"
                  format="dd-MM-yyyy"
                  :mondayFirst="true"
                  :language="datepickerLanguage"
                  :disabledDates="{
                    to: minimumSelectableDay
                  }"
                  :calendar-button="true"
                  calendar-button-icon="o-svg-icon o-svg-icon--calendar"
                  @input="updateMinimumToDate(exeption)"
                ></v-datepicker>
              </div>
              <div class="o-grid__item o-grid__item--grow-0"></div>
              <div class="o-grid__item o-grid__item--grow-0">
                {{ translationsClosedDays.toDate || "" }}
              </div>
              <div class="o-grid__item o-grid__item--4">
                <v-datepicker
                  :disabled="!isEditing"
                  input-class="c-aed-editableDate__input"
                  wrapper-class="c-aed-editableDate__wrap"
                  calendar-class="c-aed-editableDate__calendar"
                  v-model="exeption.end"
                  :use-utc="false"
                  format="dd-MM-yyyy"
                  :mondayFirst="true"
                  :language="datepickerLanguage"
                  :disabledDates="{
                    to: minimumToDay(exeption.begin)
                  }"
                  :calendar-button="true"
                  calendar-button-icon="o-svg-icon o-svg-icon--calendar"
                ></v-datepicker>
              </div>
            </div>
          </div>
        </div>
        <div
          class="o-grid__item o-grid__item--grow-0 o-grid__item--align-right"
        >
          <button
            v-if="isEditing"
            class="o-button o-button--action o-button--round o-button--light"
            @click="deleteExeption(index)"
          >
            <svg
              class="o-svg-icon o-button__icon"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use xlink:href="spritemap.svg#sprite-delete" x="0" y="0"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-center o-field o-field--spacing-none o-field--border o-field--border-none"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <button
            type="button"
            v-if="isEditing"
            class="o-button o-button--transparent o-button--clean"
            :title="translationsClosedDays.addExeption || ''"
            @click="addExeption"
          >
            <svg
              class="o-svg-icon o-button__icon o-button__icon--action  o-button__icon--shadow o-button__icon--round"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use xlink:href="spritemap.svg#sprite-plus" x="0" y="0"></use>
            </svg>
            <span>{{ translationsClosedDays.addExeption || "" }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { da } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  name: "c-closedDays",
  data() {
    return {
      section: "availability",
      name: "Tilgængelighed",
      resetKey: 0,
      datepickerLanguage: da
    };
  },
  props: {
    isEditing: { type: Boolean, default: false }
  },
  computed: {
    ...mapState("availability", {
      availabilityAll: "all",
      defaultTimeSpan: "defaultTimeSpan",
      defaultClosed: "defaultClosed"
    }),
    ...mapGetters("aed", ["minimumSelectableDay"]),
    ...mapState("translations", {
      translationsAvailabilityFull: "availability"
    }),
    translationsClosedDays() {
      return this.translationsAvailabilityFull.closedDays;
    }
  },
  methods: {
    dateFormater(date) {
      return moment(date).format("dd-MM-YYYY");
    },
    addExeption() {
      this.availabilityAll.closed.push(
        JSON.parse(JSON.stringify(this.defaultClosed))
      );
    },
    deleteExeption(index) {
      this.availabilityAll.closed.splice(index, 1);
    },
    minimumToDay(fromDate) {
      return moment(fromDate)._d;
    },
    updateMinimumToDate(exeption) {
      if (moment(exeption.begin).isAfter(exeption.end)) {
        this.$set(exeption, "end", exeption.begin);
      }
    }
  }
};
</script>

<style lang="scss">
.c-closedDays {
}
</style>
